/**
 * Unescapes Markdown syntax characters in LaTeX expressions
 * Removes backslashes before common characters that might be escaped by Google Docs
 */
export function unescapeMarkdownForLaTeX(text: string): string {
  // Characters to unescape: =_*{}[]<>()#+-.!|` and \ itself
  return text.replace(/\\([=_*{}[\]<>()+\-#.!|`\\])/g, '$1');
}
